import {
Button,
Modal,
ModalBody,
ModalCloseButton,
ModalContent,
ModalHeader,
ModalOverlay,

useToast
} from '@chakra-ui/react';
import React,{ useCallback } from 'react';
import TicTacToeGame from '../../classes/TicTacToeGame';
import useCoveyAppState from '../../hooks/useCoveyAppState';
import useMaybeVideo from '../../hooks/useMaybeVideo';

type JoinTicTacToeGameModalProps = {
    isOpen: boolean;
    closeModal: ()=>void;
    startGameModal: ()=>void;
    updateTicTacToeGame: (game: TicTacToeGame)=>void;
    ticTacToeGame: TicTacToeGame;
    playerXName: string;
}

/**
 * Modal that prompts a user to join an existing TicTacToeGame as player O.
 * @param JoinTicTacToeGameModalProps parameter 
 * @returns tsx representation of the modal
 */
export default function JoinTicTacToeGameModal( {isOpen, closeModal, startGameModal, updateTicTacToeGame, ticTacToeGame, playerXName} : JoinTicTacToeGameModalProps): JSX.Element {
    const {myPlayerID} = useCoveyAppState();

    const toast = useToast()
    const video = useMaybeVideo()

    const joinGame = useCallback(async () => {
      try {
        ticTacToeGame.addOccupant(myPlayerID);
        
        toast({
          title: 'Joined Tic Tac Toe Game!',
          status: 'success',
        });
        video?.unPauseGame();
        updateTicTacToeGame(ticTacToeGame);
        closeModal();
        startGameModal();
      } catch (err) {
        toast({
          title: 'Unable to join Tic Tac Toe Game',
          description: err.toString(),
          status: 'error',
        });
      }
    }, [ticTacToeGame, closeModal, toast, video, startGameModal, updateTicTacToeGame, myPlayerID]);
    return (
      <Modal isOpen={isOpen} onClose={()=>{closeModal(); video?.unPauseGame()}}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Play a tic tac toe game with {playerXName} </ModalHeader>
          <ModalCloseButton />
            <ModalBody pb={6}>
            <Button colorScheme='blue' mr={3} onClick={joinGame}>
                Join Game
              </Button>
              <Button onClick={closeModal}>Cancel</Button>
            </ModalBody>
        </ModalContent>
      </Modal>
    );
}

